window.__assetPrefix__ = 'https://mf-talent-static.crehana.com/frontend-talent-mf';